import React from 'react'
import { inject, observer } from 'mobx-react'
import queryString from 'query-string'
import Breadcrumb from '@hkpca-web/components/navigations/breadcrumb'
import LatestPostList from '@hkpca-web/components/templates/LatestPostList'
import { trimHtmlTag, toJS } from '@src/utils/commonUtil'
// import renderHTML from 'react-render-html'
import moment from 'moment'
import CategoryPicker from '@hkpca-web/components/inputs/CategoryPicker'
import { navigate } from 'gatsby'
import { withTranslation } from 'react-i18next'

import CloseIcon from '@material-ui/icons/Close';


import Flipbook from '@hkpca-web/components/viewers/Flipbook'
import Wowbook from '@hkpca-web/components/viewers/Wowbook'

@withTranslation()
@inject('initDataStore')
@observer

class Test extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      // theposition: 0,
      collapseStateList: [],
      showModal: false,
      pdfUrl: ""
    }
  }

  componentDidMount () {
    const { list } = this.props
    // window.addEventListener('scroll', this.listenToScroll)
    this.initCollapseStateList(list)
  }

  initCollapseStateList = (list) => {
    const collapseStateList = Array.from({ length: list.length }, () => true)
    this.setState({
      collapseStateList: [...this.state.collapseStateList, ...collapseStateList],
    })
  }

  tooglePostDetail = (key) => {
    const collapseStateList = this.state.collapseStateList
    collapseStateList[key] = !collapseStateList[key]
    this.setState({
      collapseStateList: collapseStateList
    })
  }

  // componentWillUnmount () {
  //   // window.removeEventListener('scroll', this.listenToScroll)
  // }

  // listenToScroll = async () => {
  //   const winScroll = document.body.scrollTop || document.documentElement.scrollTop
  //   const height = document.documentElement.scrollHeight - document.documentElement.clientHeight

  //   // const scrolled = winScroll / height
  //   // console.log(winScroll, height)

  //   if (height - winScroll < 2000) {
  //     await this.handleLoadContent()
  //   }

  //   // this.setState({
  //   //   theposition: scrolled,
  //   // })
  // }

  // handleLoadContent = async () => {
  //   window.removeEventListener('scroll', this.listenToScroll)
  //   const data = await this.props.loadContent()
  //   this.initCollapseStateList(data)
  //   if (data.length > 0) {
  //     window.addEventListener('scroll', this.listenToScroll)
  //   }
  // }

  closeModal = (url) => {
    this.setState({ showModal: false})
  
  }

  handleClick = (url, redirectUrl) => {
    if (redirectUrl) {
      // navigate(redirectUrl)
      if(redirectUrl.includes(".pdf")!==false) {
        this.setState({ showModal: true, pdfUrl: redirectUrl })
      } else {
        window.open(redirectUrl, "_blank")
      }

    } else {
      navigate(url)
    }
  }

  render () {
    const { i18n, list, path } = this.props
    // toJS(path)
    const { handleClick, closeModal, tooglePostDetail } = this
    const { collapseStateList } = this.state
    if (!collapseStateList) {
      return (<></>)
    }
    return (
      <>
        <div
          className='post-list'
        >
          {this.state.showModal && <Wowbook file={this.state.pdfUrl}/>}
          {this.state.showModal && <div style={{position:'fixed',right:10,top:10,zIndex:9999,color:'white'}} onClick={closeModal.bind(this)}><CloseIcon /></div> }
          {
            list.map((post, key) => {
              return (
                <div className='post' key={key}>
                  <div className='card'>
                    {
                      post.image.length > 0 && post.image[0] &&
                      <div className='image' onClick={handleClick.bind(this, `${path}?id=${post.id}`, post.redirectUrl)}>
                        <img src={post.image[0].original.replace('http://', 'https://')} alt="" />
                      </div>
                    }
                    <div className='content'>
                      <div className='title' onClick={handleClick.bind(this, `${path}?id=${post.id}`, post.redirectUrl)}>
                        {post.title[i18n.language]}
                      </div>
                      <div className='date'>
                        {
                          post.displayDateTime &&
                          moment(post.displayDateTime.split('.')[0] + "Z").format('YYYY-MM-DD')
                        }
                      </div>
                      <div className='description' onClick={handleClick.bind(this, `${path}?id=${post.id}`, post.redirectUrl)}>
                        {post.description[i18n.language]}
                      </div>
                      <div className='read-all-button' onClick={handleClick.bind(this, `${path}?id=${post.id}`, post.redirectUrl)}>{i18n.t('other.readAll')}</div>
                    </div>
                  </div>
                  <hr />
                </div>
              )
            })
          }
        </div>
      </>
    )
  }
}

export default Test
